exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".banner-placeholder-row[data-v-7a6a7843]{padding:10px}", "", {"version":3,"sources":["/app/src/components/common/ExcBand.vue"],"names":[],"mappings":"AACA,yCACE,YAAc,CACf","file":"ExcBand.vue","sourcesContent":["\n.banner-placeholder-row[data-v-7a6a7843] {\n  padding: 10px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-7a6a7843","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/ExcBand.vue
// module id = 2071
// module chunks = 13